module.exports = __webpack_public_path__ + "img/autospin_btn.f2c6bf66.png";